import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Head from "../components/commons/Head";
import Item from '../components/commons/Item';
import EventDialog from '../components/events/EventDialog';
import { IEvent } from "../models/IEvent";
import { IWording } from "../models/IWording";

const eventsWordings: IWording = require("../assets/configuration/wordings/events.json");
const eventsDatabase: IEvent[] = require("../assets/configuration/database/events.json");

const EventsView = () => {

    const {id} = useParams();
    const [event, setEvent] = useState({} as IEvent);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (id) {
            const e = filterEventById(id);
            if (e.name) openDialog(e);
        }
    }, [id]);
    
    const openDialog = (event: IEvent) => {
        setEvent(event);
        setOpen(true);
    }

    const handleClose = () => setOpen(false);

    const filterEventById = (id: string): IEvent => {
        const filteredEvents = eventsDatabase.filter(f => f.id === id);
        return filteredEvents.length > 0 ? filteredEvents[0] : {} as IEvent;
    }

    return <>
        <Head title={eventsWordings.title} description={eventsWordings.description} />

        <Grid container spacing={2} sx={{marginTop: '40px'}}>
            {eventsDatabase.map(event =>
                <Grid item key={event.date} xs={6} md={4} lg={2} xl={2}>
                    <Item label={event.name} image={event.image} fontSize={20} onClick={() => openDialog(event)}/>
                </Grid>)
            }
        </Grid>

        {open && <EventDialog event={event} open={open} onClose={handleClose} />}
    
    </>
}

export default EventsView;